export default {"src":"/_next/static/media/location.6efd8fe4.svg","height":18,"width":13,"blurWidth":0,"blurHeight":0};